import Vue from 'vue'

export async function getReservasCalendario(context, [access_token, from, until, loading]) {
    try {
        if (access_token) {
            if (loading){
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/reservas_calendario',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params:{
                    from,
                    until
                }
            })
            context.commit('reservas/setReservasCalendario', response.data, { root: true })
        }
   
    } catch (e) {
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}

export async function getReservas(context, [access_token, params, loading]) {
    try {
        if (access_token) {
            if (loading){
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/reservas',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: params
            })
            context.commit('reservas/setReservas', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}


export async function getDisponibilidadAnual(context, [access_token, year]) {
    try {
        if (access_token) {
            context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'GET',
                url: '/info_anual?year=' + year.toString(),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
       context.commit('setLoading', false, { root: true })
    }
}

export async function crearReserva(context, [access_token, modelReserva]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/reservas',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                   modelReserva
                }
            })
           if (response && response.status == 201 && response.data && response.data.data){
            return response.data.data;
           }
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}

export async function updateReserva(context, [access_token, modelReserva]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/update_reserva',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    modelReserva
                }
            })
           
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}

export async function asignarNumeroFactura(context, [access_token, reserva_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/asignar_numero_factura',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    reserva_id
                }
            })
           if (response && response.status == 201 && response.data){
            return response.data.factura;
           }
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}

export async function eliminarReserva(context, [access_token, reserva_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/reservas/' + reserva_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            if (response.status == 200) {
               // context.commit('reservas/actDeleteListReservas', reserva_id, { root: true })
               }
            return response;
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}


